// extracted by css-extract-rspack-plugin
export default {"overlay":"vBh51sKKxQM4f7aH","modal":"P5NJ2M3nP8owrSIR"};